/**
 * @typedef {object} BaseInsuranceRequest
 * @property {string} applicationId
 * */
/**
 * @typedef {BaseInsuranceRequest} InsuranceRequest
 * @property {Parameters} parameters
 *
 * @template Parameters
 * */
/**
 * @typedef {object} InsuranceMoveToInsurerInfoWithParamsRequest
 * @property {number} [bankId]
 * @property {string} brandAsPTS - Марка как в ПТС
 * @property {boolean} isInCredit - Авто в кредит?
 * @property {string} modelAsPTS - Модель как в ПТС
 * @property {'commercial' | 'personal' | 'taxi'} typeOfUse - Цель использования
 * */
/**
 * @typedef {object} InsuranceMoveToInsuranceProductsWithParamsRequest
 * @property {number} [minDriversAge] - Минимальный возраст водителя
 * @property {number} [minDriversExperience] - Минимальный опыт водителя
 * @property {boolean} multidrive - Мультидрайв или ограниченный список водителей
 * */

import { AxiosError } from 'axios';

import appRequest from 'utils/request';

const errorHandler = (error) => {
  const { config, response, request } = error ?? {};
  const { data, headers, status } = response ?? {};
  const { errors } = data ?? {};

  if (!Array.isArray(errors)) {
    throw error;
  }

  throw new AxiosError('Bad request', AxiosError.ERR_BAD_REQUEST, config, request, {
    data: errors.reduce((acc, { message, property }) => {
      return { ...acc, [property]: message };
    }, {}),
    headers,
    status,
  });
};

/**
 * @description Перейти к настройкам продуктов
 * @param {InsuranceRequest<InsuranceMoveToInsurerInfoWithParamsRequest>} params
 * @return {Promise<void>}
 * */
export const moveToInsurerInfoWithParams = async (params) => {
  try {
    const response = await appRequest.post(
      '/api/insurance/move-to-insurance-products-with-params',
      params
    );

    return response;
  } catch (error) {
    throw errorHandler(error);
  }
};

/**
 * @description Перейти к списку водителей
 * @param {BaseInsuranceRequest} params
 * @return {Promise<void>}
 * */
export const moveToDriversList = async (params) => {
  try {
    const response = await appRequest.post('/api/insurance/move-to-drivers-list', params);

    return response;
  } catch (error) {
    throw errorHandler(error);
  }
};

/**
 * @description Перейти к настройкам продуктов
 * @param {InsuranceRequest<InsuranceMoveToInsuranceProductsWithParamsRequest>} params
 * @return {Promise<void>}
 * */
export const moveToInsuranceProductsWithParams = async (params) => {
  try {
    const response = await appRequest.post(
      '/api/insurance/move-to-insurance-products-with-params',
      params
    );

    return response;
  } catch (error) {
    throw errorHandler(error);
  }
};

/**
 * @description Вернуться назад
 * @param {BaseInsuranceRequest} params
 * @return {Promise<void>}
 * */
export const moveToPreviousState = async (params) => {
  try {
    const response = await appRequest.post('/api/insurance/move-to-previous-state', params);

    return response;
  } catch (error) {
    throw errorHandler(error);
  }
};
